import { render, staticRenderFns } from "./SessionsList.vue?vue&type=template&id=01fa5e4a&scoped=true&"
import script from "./SessionsList.vue?vue&type=script&lang=js&"
export * from "./SessionsList.vue?vue&type=script&lang=js&"
import style0 from "./SessionsList.vue?vue&type=style&index=0&id=01fa5e4a&lang=scss&scoped=true&"
import style1 from "./SessionsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa5e4a",
  null
  
)

export default component.exports